import { Avatar } from "primereact/avatar";
import { Menu } from "primereact/menu";
import { Menubar } from "primereact/menubar";
import { useNavigate } from "react-router-dom";
import useUser from "../hooks/UserHook";
import { Skeleton } from 'primereact/skeleton';

const items = (navigate) => [
	{
		label: 'Geral',
		items: [
			{ label: 'Visão geral', icon: 'pi pi-fw pi-home', command: () => navigate('/') },
			{ label: 'Produtos', icon: 'pi pi-box', command: () => navigate('/products') },
			{ label: 'Usuários', icon: 'pi pi-user', command: () => navigate('/users') },
			{ label: 'Distribuidoras', icon: 'pi pi-link', command: () => navigate('/suppliers') },
			{ label: 'Clientes', icon: 'pi pi-briefcase', command: () => navigate('/clients') },
			{ label: 'Pedidos', icon: 'pi pi-shopping-cart', command: () => navigate('/orders') },
			{ label: 'Movimentações', icon: 'pi pi-arrow-right-arrow-left', command: () => navigate('/movements') },
			{ label: 'Tabelas de preço', icon: 'pi pi-dollar', command: () => navigate('/price-tables') },
		],
	},
	{
		label: 'Configurações',
		items: [
			{ label: 'Configurações da empresa', icon: 'pi pi-cog', command: () => navigate('/industry-configurations') },
		],
	}
];

const Logo = ({ className }) => (
	<img src="/eztoque-logo.svg" width={150} className={className}/>
);

export const TopMenu = () => {
	const navigate = useNavigate();

	return (
		<Menubar end={Logo} model={items(navigate)} className='md:hidden'/>
	);
}

export const LateralMenu = () => {
	const navigate = useNavigate();

	return (
		<>
			<Logo className='mb-4 ml-3 mt-2'/>
			<div className='flex-grow-1'>
				<Menu className='w-full lateral-menu font-medium' model={items(navigate)} />
			</div>
			<div className='flex align-items-center'>
				<UserInfo/>
			</div>
		</>
	);
};

const UserInfo = () => {

	const { self, loading } = useUser();

	if (loading) return (
		<>
			<Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
			<div>
				<Skeleton width="10rem" className="mb-2"></Skeleton>
				<Skeleton width="10rem" height=".6rem" className="mb-2"></Skeleton>
			</div>
		</>
	);

	return (
		<>
			<Avatar icon="pi pi-user" size="large" shape="circle" className='mr-2'/>
			<div>
				<div className='font-medium'>{self.name}</div>
				<div className='text-color-secondary text-xs'>{self.loginName}@{self.company.loginDomain}</div>
			</div>
		</>
	)
}